import { Link } from 'react-router-dom';
import { PRODUCT_DISPLAY_NAME } from '../../../../shared/constants/branding';
import { MOBILE_APP } from '../../../../shared/constants/mobileApp';

export default function MarketplaceFooter() {
  return (
    <footer className="marketplace-footer">
      <div className="marketplace-container marketplace-footer-inner">
        <p className="marketplace-footer-copy">
          © {new Date().getFullYear()} {PRODUCT_DISPLAY_NAME} Property Marketplace
        </p>
        <nav className="marketplace-footer-links" aria-label="Footer">
          <Link to="/privacy">Privacy</Link>
          <Link to="/contact-sales">Contact</Link>
          <Link to="/about">About</Link>
          <a href={`mailto:${MOBILE_APP.supportEmail}`}>{MOBILE_APP.supportEmail}</a>
        </nav>
      </div>
    </footer>
  );
}
